import anObject$1 from './an-object.js';
import iteratorClose$1 from './iterator-close.js';

var anObject = anObject$1;
var iteratorClose = iteratorClose$1; // call something on iterator step with safe closing on error

var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

export { callWithSafeIterationClosing as default };
